















import '@/assets/css/components/button-select.css';
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

export type ItemType = {
    id: number|string,
    value: string,
}

@Component({
    name: 'ButtonSelect',
})
export default class ButtonSelect extends Vue {
    @Model('change', { type: Object, default: null }) value!: ItemType|null;
    @Prop({ type: Array, default: () => ([]) }) items!: ItemType[];
    @Prop({ type: Boolean, default: false }) noPick!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;

    val = this.value;

    change (item: ItemType) {
        if (!this.noPick) this.val = item;
        this.$emit('change', item);
    }

    @Watch('value')
    onValueChange (newVal: ItemType) {
        this.val = newVal;
    }
}
